/*------------------------------------------------------
 * JQuery
 *------------------------------------------------------
 * Registra a biblioteca JQuery com uma dependência
 * gloabl
 */
window.$ = require('jquery');
window.jQuery = $;
window.moment = require('moment');
window._ = require('lodash');
window.signalr = require('signalr');
window.toastr = require('toastr');
window.saveAs = require('file-saver').saveAs

import logEvents from 'compartilhado/plugins/log-events.plugin';

import * as angular from 'angular';

import './config/simditor.js';

import 'angular-animate';
import 'angular-cookies';
import 'angular-drop-image';
import 'angular-i18n/pt-br';
import 'angular-notification';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular-strap';
import 'angular-ui-router';
import 'angular-ui-sortable';
import 'angular-paging';
import 'angular-loading-bar';
import 'ngstorage';
import 'ui-select';
import 'ng-plugin';

/*------------------------------------------------------
 * Registra o modulo app
 *------------------------------------------------------
 * Armazenamos a instancia da plicação no container
 * window para podermos executar testes em tempo de
 * execução.
 */
angular.module('bootstrap', [
    'ngLocale',
    'ui.router',
    'ngResource',
    'ngCookies',
    'ngRoute',
    'ngStorage',
    'ngSanitize',
    'ngDropImage',
    'angular-loading-bar',
    'angular-simditor',
    'ui.sortable',
    'notification',
    'mgcrea.ngStrap',
    'ui.select',
    'bw.paging'
]);


// WEBPACK FOOTER //
// ./src/core/bootstrap.js